import { useTranslation } from "react-i18next";

export const HeaderSection = () => {
  const { t } = useTranslation();

  return (
    <div className='w-full flex flex-col gap-1 mb-5'>
      <h1 className='text-base font-medium text-[rgba(16,24,40,1)]'>{t('agent_dashboard.company_asset.title')}</h1>
      <p className='text-sm font-normal text-[rgba(102,112,133,1)]'>
        {t('agent_dashboard.company_asset.description')}
      </p>
    </div>
  )
}
